import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { createGlobalStyle } from 'styled-components'
import { ReactComponent as Logo } from '@assets/images/logo.svg'
import CommonFormInput from '@components/common/CommonFormInput'
import CommonButton from '@components/common/CommonButton'
import { useUserContext } from '@hooks/useUserContext'

const SignupPage = () => {
  const { handleSignup } = useUserContext()
  const [userInfo, setUserInfo] = useState({
    fullName: '',
    email: '',
    password: '',
    passwordConfirm: '',
  })

  const setUserInfoValue = e => {
    const { name, value } = e.target
    setUserInfo({ ...userInfo, [name]: value })
  }

  const signUp = () => {
    if (userInfo.password !== userInfo.passwordConfirm) {
      alert('비밀번호가 다릅니다!')
      return false
    }

    handleSignup(userInfo)
  }

  return (
    <>
      <SignupPageStyle />
      <div className="main-wrapper">
        <Logo
          className="header-logo"
          style={{ width: '50px', height: '50px' }}
        />
      </div>
      <CommonFormInput
        name="fullName"
        className="form-item"
        label="사용자 명"
        fontWeight="normal"
        fontSize={16}
        tag="h3"
        width="100%"
        placeholder="사용자명을 입력해주세요"
        onChange={setUserInfoValue}
      />
      <CommonFormInput
        name="email"
        className="form-item"
        label="이메일"
        fontWeight="normal"
        fontSize={16}
        tag="h3"
        width="100%"
        placeholder="이메일을 입력해주세요"
        onChange={setUserInfoValue}
      />
      <CommonFormInput
        name="password"
        type="password"
        className="form-item"
        label="비밀번호"
        fontWeight="normal"
        fontSize={16}
        tag="h3"
        width="100%"
        placeholder="비밀번호를 입력해주세요"
        onChange={setUserInfoValue}
      />
      <CommonFormInput
        name="passwordConfirm"
        type="password"
        className="form-item"
        label="비밀번호 확인"
        fontWeight="normal"
        fontSize={16}
        tag="h3"
        width="100%"
        placeholder="비밀번호를 다시 입력해주세요"
        onChange={setUserInfoValue}
      />
      <div className="main-wrapper">
        <CommonButton
          className="button-item"
          text="회원 가입"
          width="100%"
          height={70}
          backgroundColor="#ffa34b"
          fontSize={20}
          color="#FFFFFF"
          onClick={signUp}
        />
      </div>
    </>
  )
}

SignupPage.propTypes = {}

const SignupPageStyle = createGlobalStyle`
    .main-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .header-logo {
        margin-top: 40px;
        margin-bottom: 80px;
    }

    .form-item {
        margin-top: 25px;
    }

    .button-item {
        margin-top: 60px;
    }
`

export default SignupPage
